import { defineModule, defineRoute } from "../../shared/define-module"
import type { ExportDataRequest, ExportDataResponse } from "./types"

/**
 * Data module for data export operations
 */
export const dataModule = defineModule({
  name: "data",
  prefix: "/data",
  routes: {
    // Export user data
    export: defineRoute<ExportDataRequest, ExportDataResponse>("GET", "/g"),
  },
})

// Export the API type
export type DataAPI = typeof dataModule.api

// Re-export types for external consumption
export type * from "./types"
